import { render } from "./HelloWorld.vue?vue&type=template&id=2f7baef2&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=2f7baef2&scoped=true&lang=css"

import exportComponent from "/home/flow/draceo/clients/interne/projets/glitch-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7baef2"]])

export default __exports__